Object.defineProperty(exports, "__esModule", { value: true });
function fillObject(dest, src) {
    for (var key in src) {
        if (!dest.hasOwnProperty(key)) {
            dest[key] = src[key];
        }
    }
    return dest;
}
exports.fillObject = fillObject;
